var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wire-transfer-info',{attrs:{"id":_vm.id,"isDraft":_vm.isDraft,"isTemplate":_vm.isTemplate}})
}
var staticRenderFns = []

export { render, staticRenderFns }